import React, {FC} from 'react';
import {Container} from "react-bootstrap";

const NotFoundPage: FC = () => {
	return (
		<Container>
			<div className="text-center">Stránka nenalezena.</div>
		</Container>
	);
};

export default NotFoundPage;
